import { configureStore } from "@reduxjs/toolkit";

import announcementReducer from "./announcement";
import authReducer from "./auth";
import bankReducer from "./bank";
import bettingRecordReducer from "./bettingrecord";
import contactReducer from "./contact";
import depositReducer from "./deposit";
import featureReducer from "./feature";
import gameReducer from "./game";
import masterReducer from "./master";
import memberReducer from "./member";
import modalReducer from "./modal";
import ordersReducer from "./orders";
import referralReducer from "./referral";
import retriveReducer from "./retrive";
import uiReducer from "./uiSlice";
import userReducer from "./user";
import withdrawReducer from "./withdraw";

const rootReducers = {
  auth: authReducer,
  user: userReducer,
  game: gameReducer,
  retrive: retriveReducer,
  bank: bankReducer,
  deposit: depositReducer,
  withdraw: withdrawReducer,
  orders: ordersReducer,
  bettingRecord: bettingRecordReducer,
  announcement: announcementReducer,
  contact: contactReducer,
  modal: modalReducer,
  member: memberReducer,
  master: masterReducer,
  referral: referralReducer,
  feature: featureReducer,
  ui: uiReducer,
};

const store = configureStore({
  reducer: rootReducers,
});

export default store;
